const gridNames = {
    administrationInvoices: 'administrationInvoices',
    administrationNotificationTemplates: 'administrationNotificationTemplates'
};

export default gridNames;
